import React from 'react';
import './Shimmer.css';

// Shimmer skeleton components for different UI elements
export const ShimmerCard = ({ width = '100%', height = '120px' }) => (
  <div className="shimmer-card" style={{ width, height }}>
    <div className="shimmer-shine"></div>
  </div>
);

export const ShimmerStatCard = () => (
  <div className="shimmer-stat-card">
    <div className="shimmer-icon"></div>
    <div className="shimmer-content">
      <div className="shimmer-line shimmer-line-large"></div>
      <div className="shimmer-line shimmer-line-small"></div>
    </div>
    <div className="shimmer-shine"></div>
  </div>
);

export const ShimmerTableRow = ({ columns }) => (
  <tr className="shimmer-table-row">
    {Array.from({ length: columns}).map((_, idx) => (
      <td key={idx}>
        <div className="shimmer-line"></div>
      </td>
    ))}
    <div className="shimmer-shine"></div>
  </tr>
);

export const ShimmerTableHeader = ({ columns }) => (
  <tr className="shimmer-table-row shimmer-table-head">
    {Array.from({ length: columns }).map((_, idx) => (
      <th key={idx}>
        <div className="shimmer-line shimmer-line-head"></div>
      </th>
    ))}
    <div className="shimmer-shine"></div>
  </tr>
);

export const ShimmerListItem = () => (
  <div className="shimmer-list-item">
    <div className="shimmer-avatar"></div>
    <div className="shimmer-content">
      <div className="shimmer-line shimmer-line-medium"></div>
      <div className="shimmer-line shimmer-line-small"></div>
    </div>
    <div className="shimmer-shine"></div>
  </div>
);

export const ShimmerButton = ({ width = '120px', height = '40px' }) => (
  <div className="shimmer-button" style={{ width, height }}>
    <div className="shimmer-shine"></div>
  </div>
);

export const ShimmerText = ({ lines = 3, width = '100%' }) => (
  <div className="shimmer-text" style={{ width }}>
    {Array.from({ length: lines }).map((_, idx) => (
      <div key={idx} className="shimmer-line" style={{ width: idx === lines - 1 ? '80%' : '100%' }}></div>
    ))}
    <div className="shimmer-shine"></div>
  </div>
);

export default ShimmerCard;

